import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// body('cycleId').isMongoId(),
//   body('moduleType').isIn(Object.values(MODULE_TYPE)),
//   body('questionId').isMongoId(),
//   body('answer').isString(),
export const generateFollowUpQuestion = (params) =>
  instance.post(`/web-app/user/ai/generate-follow-up-question`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// ('/rate-ai-usage', [
//     body('aiUsageId')
//     body('reaction')
//     body('comment')
export const sendAIRate = (params) =>
  instance.post(`/web-app/user/ai/rate-ai-usage`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
